(function() {
  var __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  vtex.define('shipping/script/component/AddressForm',['flight/lib/component', 'shipping/script/setup/extensions', 'shipping/script/models/Address', 'shipping/script/module/alphanumponc', 'shipping/templates/googleMaps/map', 'shipping/script/mixin/withi18n', 'shipping/script/mixin/withCreateMap', 'shipping/script/mixin/withGoogleMaps', 'shipping/script/mixin/withValidation', 'shipping/script/mixin/withImplementedCountries'], function(defineComponent, extensions, Address, alphanumponc, mapTemplate, withi18n, withCreateMap, withGoogleMaps, withValidation, withImplementedCountries) {
    var AddressForm;
    AddressForm = function() {
      var fixFieldWithMultipleOptions,
        _this = this;
      this.defaultAttrs({
        map: false,
        marker: false,
        addressKeyMap: {},
        reRenderUniversalPostalCode: false,
        data: {
          address: null,
          disableCityAndState: false,
          labelShippingFields: false,
          addressSearchResults: {},
          countryRules: {},
          hasGeolocationData: false,
          contractedShippingFieldsForGeolocation: false,
          addressQuery: false,
          comeFromGeoSearch: false,
          isUniversalUsingPostalCode: true,
          shouldShowPostalCode: true
        },
        templates: {
          universalPostalCode: {
            name: 'universalPostalCode',
            path: 'shipping/templates/universalPostalCode'
          },
          form: {
            baseName: 'countries/addressForm'
          }
        },
        addressFormSelector: '.address-form-new',
        postalCodeSelector: '.postal-code',
        forceShippingFieldsSelector: '#force-shipping-fields',
        stateSelector: '#ship-state',
        citySelector: '#ship-city',
        neighborhoodSelector: '#ship-neighborhood',
        basedOnStateChange: 'select[data-based-state-change="true"]',
        basedOnCityChange: 'select[data-based-city-change="true"]',
        selectizeSelect: 'select[data-selectize="true"]',
        submitButtonSelector: '.submit .btn-success.address-save',
        mapCanvasSelector: '#map-canvas',
        addressInputsSelector: '.box-delivery input',
        findAPostalCodeForAnotherAddressSelector: '.find-a-postal-code-for-another-address',
        universalPostalCodePlaceholderSelector: '.ship-postal-code-uni-container',
        universalPostalCodeSelector: '.postal-code-UNI',
        usePostalCodeSelector: '.ship-use-postal-code',
        dontUsePostalCodeSelector: '.ship-dont-use-postal-code',
        searchAnotherAddressSelector: '.search-another-address-btn'
      });
      this.render = function() {
        var acceptsGeoCoords, country, data, hasGeocoordinates, hasPostalCode, postalCodeGeolocation, rules, _ref, _ref1,
          _this = this;
        data = this.attr.data;
        if (this.attr.reRenderUniversalPostalCode) {
          this.attr.reRenderUniversalPostalCode = false;
          return dust.render(this.attr.templates.universalPostalCode.name, data, function(err, output) {
            output = $(output).i18n();
            return _this.select('universalPostalCodePlaceholderSelector').html(output);
          });
        }
        dust.render(this.attr.templates.form.name, data, function(err, output) {
          var googleError, rules, select, selectOptionCreate, selectizeSelects, validatorName, _base, _i, _len, _ref;
          if (err) {
            return console.log(err);
          }
          output = $(output).i18n();
          _this.$node.html(output);
          if (!window.vtex.maps.isGoogleMapsAPILoaded && window.vtex.maps.isGoogleMapsAPILoading && _this.attr.data.hasGeolocationData) {
            _this.loading();
          }
          try {
            if (window.vtex.maps.isGoogleMapsAPILoaded && _this.attr.data.hasGeolocationData) {
              _this.attr.data.loading = false;
              _this.createMap();
            }
          } catch (_error) {
            googleError = _error;
            console.error('Error while trying to render Google Maps');
          }
          if (_this.attr.data.loading) {
            $('input, select, .btn', _this.$node).attr('disabled', 'disabled');
          }
          rules = _this.getCountryRule();
          if (((_ref = data.address) != null ? _ref.postalCode : void 0) && rules.postalCodeByInput && data.labelShippingFields) {
            _this.select('postalCodeSelector').addClass('success');
          }
          validatorName = 'postalCode';
          if (_this.attr.data.address.country === 'ARG') {
            validatorName = 'postalCodeARG';
          }
          window.ParsleyValidator.addValidator(validatorName, function(val) {
            rules = _this.getCountryRule();
            return rules.regexes.postalCode.test(val);
          }, 32);
          _this.attr.parsley = _this.select('addressFormSelector').parsley({
            errorClass: 'error',
            successClass: 'success',
            errorsWrapper: '<span class="help error error-list"></span>',
            errorTemplate: '<span class="error-description"></span>'
          });
          _this.attr.parsley.subscribe('parsley:field:validated', function() {
            var valid;
            valid = _this.attr.parsley.isValid();
            return _this.updateAddress(valid);
          });
          selectizeSelects = _this.select('selectizeSelect');
          for (_i = 0, _len = selectizeSelects.length; _i < _len; _i++) {
            select = selectizeSelects[_i];
            if ($(select).data('selectize-create')) {
              selectOptionCreate = true;
            } else {
              selectOptionCreate = false;
            }
            if (typeof (_base = $(select)).selectize === "function") {
              _base.selectize({
                create: selectOptionCreate,
                render: {
                  option_create: function(data, escape) {
                    var addString;
                    addString = window.i18n.t('global.add');
                    return '<div class="create">' + addString + ' <strong>' + escape(data.input) + '</strong>&hellip;</div>';
                  }
                }
              });
            }
          }
          if (_this.attr.data.address.validate(rules) === true) {
            return _this.attr.parsley.validate();
          } else {
            return _this.select('addressInputsSelector').each(function() {
              if (this.value === '') {
                this.focus();
                return false;
              } else {
                return this.blur();
              }
            });
          }
        });
        country = this.attr.data.address.country;
        rules = this.getCountryRule();
        if (rules) {
          postalCodeGeolocation = _.find(rules.googleDataMap, function(r) {
            return r.value === 'postalCode';
          });
          hasGeocoordinates = ((_ref = this.attr.data.address.geoCoordinates) != null ? _ref.length : void 0) > 0;
          acceptsGeoCoords = (__indexOf.call((_ref1 = this.attr.data.logisticsConfiguration) != null ? _ref1.acceptSearchKeys : void 0, 'geoCoords') >= 0);
          if (hasGeocoordinates && acceptsGeoCoords) {
            return this.attr.data.shouldShowPostalCode = postalCodeGeolocation.required;
          } else {
            hasPostalCode = _.find(rules.requiredFields, function(r) {
              return r === 'postalCode';
            });
            return this.attr.data.shouldShowPostalCode = !!hasPostalCode;
          }
        }
      };
      this.getCountryRule = function() {
        return this.attr.data.countryRules[this.attr.data.address.country];
      };
      this.validateAddress = function() {
        var valid;
        valid = this.attr.parsley.validate();
        if (valid) {
          this.updateAddress(true);
        } else if (this.attr.data.address.isValid) {
          this.updateAddress(false);
        }
        return valid;
      };
      this.isDifferentGeoCoords = function(a, b) {
        if (a && !b || !a && b || a.length > 0 && b.length === 0 || a.length === 0 && b.length > 0) {
          return true;
        }
        return a[0] !== b[0] && a[1] !== b[1];
      };
      this.addressKeysUpdated = function(ev) {
        var countryQueryByPostalCode, countryRules, countryUsePostalCodeByInput, currentAddressKeyMap, geoCoordsChanged, hasGeolocationData, postalCodeChanged, postalCodeChangedByInput, postalCodeChangedFromValidToInvalid, storeAcceptsGeoCoords, storeAcceptsPostalCode;
        if (ev != null) {
          ev.preventDefault();
        }
        storeAcceptsPostalCode = this.attr.data.storeAcceptsPostalCode;
        storeAcceptsGeoCoords = this.attr.data.storeAcceptsGeoCoords;
        hasGeolocationData = this.attr.data.hasGeolocationData;
        countryRules = this.getCountryRule();
        countryUsePostalCodeByInput = countryRules.postalCodeByInput;
        countryQueryByPostalCode = countryRules.queryByPostalCode;
        currentAddressKeyMap = this.getCurrentAddress();
        geoCoordsChanged = this.isDifferentGeoCoords(this.attr.addressKeyMap.geoCoordinates, currentAddressKeyMap.geoCoordinates);
        if (geoCoordsChanged && currentAddressKeyMap.useGeolocationSearch) {
          this.trigger('addressKeysUpdated.vtex', [currentAddressKeyMap]);
        } else {
          postalCodeChangedFromValidToInvalid = this.attr.addressKeyMap.postalCodeIsValid && !currentAddressKeyMap.postalCodeIsValid;
          postalCodeChanged = this.attr.addressKeyMap.postalCode !== currentAddressKeyMap.postalCode;
          if (postalCodeChanged) {
            postalCodeChangedByInput = ev != null;
            if (currentAddressKeyMap.postalCodeIsValid || (!postalCodeChangedByInput && currentAddressKeyMap.geoCoordinatesIsValid)) {
              this.trigger('addressKeysUpdated.vtex', [currentAddressKeyMap]);
            }
          } else {
            if ((!storeAcceptsGeoCoords && countryQueryByPostalCode) || (storeAcceptsGeoCoords && !currentAddressKeyMap.geoCoordinatesIsValid)) {
              this.trigger('addressKeysInvalidated.vtex', [currentAddressKeyMap]);
            }
          }
        }
        return this.attr.addressKeyMap = currentAddressKeyMap;
      };
      this.findAnotherPostalCode = function() {
        var addressKeyMap, _ref, _ref1;
        addressKeyMap = {
          country: (_ref = this.attr.data.address) != null ? _ref.country : void 0,
          addressId: (_ref1 = this.attr.data.address) != null ? _ref1.addressId : void 0,
          useGeolocationSearch: true,
          postalCode: {
            value: null,
            valid: false
          },
          geoCoordinates: {
            value: [],
            valid: false
          }
        };
        return this.trigger('addressKeysInvalidated.vtex', [addressKeyMap]);
      };
      this.forceShippingFields = function() {
        this.attr.data.contractedShippingFieldsForGeolocation = false;
        this.attr.data.labelShippingFields = false;
        this.attr.data.labelFields = null;
        return this.render();
      };
      this.getCurrentAddress = function() {
        var addressObj, disabled, serializedForm;
        disabled = this.select('addressFormSelector').find(':input:disabled').removeAttr('disabled');
        serializedForm = this.select('addressFormSelector').find('select,textarea,input').serializeArray();
        disabled.attr('disabled', 'disabled');
        addressObj = {};
        $.each(serializedForm, function() {
          var attrName;
          attrName = this.name === 'receiver' ? 'receiverName' : this.name;
          return addressObj[attrName] = (this.value != null) && (this.value !== "") ? this.value : null;
        });
        if (addressObj.addressTypeCommercial) {
          addressObj.addressType = 'commercial';
        } else {
          addressObj.addressType = 'residential';
        }
        if (addressObj.postalCode) {
          addressObj.postalCode = addressObj.postalCode.replace(/\-/, '');
        }
        addressObj.geoCoordinates = this.attr.data.address.geoCoordinates || [];
        if (!this.attr.data.storeAcceptsGeoCoords) {
          addressObj.geoCoordinates = [];
        }
        if (this.getCountryRule().postalCodeByInput) {
          addressObj.postalCodeIsValid = this.postalCodeIsValid();
        } else {
          addressObj.postalCodeIsValid = addressObj.postalCode !== null;
        }
        addressObj.geoCoordinatesIsValid = addressObj.geoCoordinates.length === 2;
        if (this.attr.data.storeAcceptsGeoCoords && addressObj.geoCoordinatesIsValid) {
          addressObj.useGeolocationSearch = true;
        } else {
          addressObj.useGeolocationSearch = false;
        }
        return addressObj;
      };
      this.postalCodeIsValid = function() {
        var postalCodeInput, rules;
        postalCodeInput = this.select('postalCodeSelector');
        if ((typeof postaCodeInput !== "undefined" && postaCodeInput !== null ? postaCodeInput.parsley : void 0) != null) {
          return postaCodeInput.parsley().isValid();
        }
        rules = this.getCountryRule();
        return rules.regexes.postalCode.test(postalCodeInput.val());
      };
      this.updateAddress = function(isValid) {
        var currentAddress;
        currentAddress = this.getCurrentAddress();
        currentAddress.isValid = isValid;
        if (currentAddress.addressSearch === null) {
          delete currentAddress["addressSearch"];
        }
        this.attr.data.address = new Address(currentAddress);
        this.trigger('addressUpdated.vtex', [this.attr.data.address]);
        return this.attr.data.address;
      };
      this.loadCountryRulesAndTemplate = function(country) {
        var countryTemplate, deps, isImplemented,
          _this = this;
        deps = [];
        isImplemented = this.isCountryImplemented(country);
        if (isImplemented) {
          countryTemplate = country;
          this.attr.templates.form.name = this.attr.templates.form.baseName + country;
        } else {
          countryTemplate = 'UNI';
          this.attr.templates.form.name = this.attr.templates.form.baseName + 'UNI';
        }
        deps.push('shipping/script/rule/Country' + countryTemplate);
        deps.push('shipping/templates/' + this.attr.templates.form.name);
        if (!isImplemented) {
          deps.push(this.attr.templates.universalPostalCode.path);
        }
        return vtex.curl(deps, function(countryRule) {
          _this.attr.data.countryRules[country] = new countryRule();
          _this.attr.data.states = _this.attr.data.countryRules[country].states;
          _this.attr.data.regexes = _this.attr.data.countryRules[country].regexes;
          return _this.attr.data.dontKnowPostalCodeURL = _this.attr.data.countryRules[country].dontKnowPostalCodeURL;
        });
      };
      this.fillCitySelect = function() {
        var rules, state, _ref;
        rules = this.getCountryRule();
        if (!rules.basedOnStateChange) {
          return;
        }
        state = (_ref = this.attr.data.address) != null ? _ref.state : void 0;
        if (state && rules.cities[state]) {
          return this.attr.data.cities = rules.cities[state];
        }
      };
      this.fillNeighborhoodSelect = function() {
        var city, rules, state, stateCapitalize, _ref, _ref1;
        rules = this.getCountryRule();
        if (!rules.basedOnCityChange) {
          return;
        }
        state = (_ref = this.attr.data.address) != null ? _ref.state : void 0;
        stateCapitalize = _.find(rules.states, function(s) {
          return s.value === state;
        });
        city = (_ref1 = this.attr.data.address) != null ? _ref1.city : void 0;
        if (city && stateCapitalize && rules.map[stateCapitalize.label][city]) {
          return this.attr.data.neighborhoods = _.keys(rules.map[stateCapitalize.label][city]);
        }
      };
      this.changedStateHandler = function(ev, state) {
        var _ref, _ref1;
        state = (_ref = state != null ? (_ref1 = state.el) != null ? _ref1.value : void 0 : void 0) != null ? _ref : null;
        return this.changedState(state);
      };
      this.changedState = function(state) {
        if (this.getCountryRule().basedOnStateChange && state) {
          this.changeCities(state);
        }
        return this.changePostalCodeByState();
      };
      this.changedCityHandler = function(ev, city) {
        var _ref, _ref1;
        city = (_ref = city != null ? (_ref1 = city.el) != null ? _ref1.value : void 0 : void 0) != null ? _ref : null;
        return this.changedCity(city);
      };
      this.changedCity = function(city) {
        if (this.getCountryRule().basedOnCityChange) {
          this.changeNeighborhoods(city);
        }
        return this.changePostalCodeByNeighborhood();
      };
      this.changeCities = function(state) {
        var elem, options, rules, selectize, value, _i, _len, _ref, _ref1, _results;
        rules = this.getCountryRule();
        this.select('basedOnStateChange').find('option').remove().end();
        if (rules.basedOnCityChange) {
          this.select('basedOnCityChange').find('option').remove().end();
        }
        if (state === "") {
          returnfalse;
        }
        if ((_ref = this.select('basedOnStateChange')) != null ? _ref.data('selectize') : void 0) {
          selectize = this.select('basedOnStateChange')[0].selectize;
          selectize.clearOptions();
          options = _.map(rules.cities[state.toUpperCase()], function(city) {
            return {
              value: city,
              text: city
            };
          });
          selectize.addOption(options);
          return selectize.refreshOptions();
        } else {
          elem = '<option></option>';
          this.select('basedOnStateChange').append(elem);
          _ref1 = rules.cities[state.toUpperCase()];
          _results = [];
          for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
            value = _ref1[_i];
            elem = '<option value="' + value + '">' + value + '</option>';
            _results.push(this.select('basedOnStateChange').append(elem));
          }
          return _results;
        }
      };
      this.changeNeighborhoods = function(city) {
        var elem, options, rules, selectize, state, stateCapitalize, value, _i, _len, _ref, _ref1, _ref2, _results;
        rules = this.getCountryRule();
        this.select('basedOnCityChange').find('option').remove().end();
        state = this.select('stateSelector').val() || ((_ref = this.attr.data.address) != null ? _ref.state : void 0);
        stateCapitalize = _.find(rules.states, function(s) {
          return s.value === state;
        });
        if (state === "" || city === "") {
          return;
        }
        if ((_ref1 = this.select('basedOnCityChange')) != null ? _ref1.data('selectize') : void 0) {
          selectize = this.select('basedOnCityChange')[0].selectize;
          selectize.clearOptions();
          options = _.map(_.keys(rules.map[stateCapitalize.label][city]), function(neigh) {
            return {
              value: neigh,
              text: neigh
            };
          });
          selectize.addOption(options);
          return selectize.refreshOptions();
        } else {
          elem = '<option></option>';
          this.select('basedOnCityChange').append(elem);
          _ref2 = _.keys(rules.map[stateCapitalize.label][city]);
          _results = [];
          for (_i = 0, _len = _ref2.length; _i < _len; _i++) {
            value = _ref2[_i];
            elem = '<option value="' + value + '">' + value + '</option>';
            _results.push(this.select('basedOnCityChange').append(elem));
          }
          return _results;
        }
      };
      this.changePostalCodeByState = function(ev, data) {
        var city, postalCode, rules, state, stateCapitalize, _ref, _ref1;
        rules = this.getCountryRule();
        if (!rules.postalCodeByState) {
          return;
        }
        state = this.select('stateSelector').val() || ((_ref = this.attr.data.address) != null ? _ref.state : void 0);
        stateCapitalize = _.find(rules.states, function(s) {
          return s.value === state;
        });
        if (_.isObject(rules.map[stateCapitalize.label])) {
          _ref1 = rules.map[stateCapitalize.label];
          for (city in _ref1) {
            postalCode = _ref1[city];
            break;
          }
        } else {
          postalCode = rules.map[stateCapitalize.label];
        }
        this.select('postalCodeSelector').val(postalCode);
        return this.addressKeysUpdated();
      };
      this.changePostalCodeByCity = function(ev, data) {
        var postalCode, rules, state, stateCapitalize, value, _ref, _ref1;
        rules = this.getCountryRule();
        if (!rules.postalCodeByCity) {
          return;
        }
        state = this.select('stateSelector').val() || ((_ref = this.attr.data.address) != null ? _ref.state : void 0);
        value = this.select('basedOnStateChange').val();
        stateCapitalize = _.find(rules.states, function(s) {
          return s.value === state;
        });
        if (!stateCapitalize || value === "") {
          return;
        }
        postalCode = (_ref1 = rules.map[stateCapitalize.label]) != null ? _ref1[value] : void 0;
        if (!postalCode) {
          return;
        }
        this.select('postalCodeSelector').val(postalCode);
        return this.addressKeysUpdated();
      };
      this.changePostalCodeByNeighborhood = function(ev, data) {
        var city, neighborhood, postalCode, rules, state, stateCapitalize, _ref, _ref1, _ref2, _ref3;
        rules = this.getCountryRule();
        if (!rules.postalCodeByNeighborhood) {
          return;
        }
        state = this.select('stateSelector').val() || ((_ref = this.attr.data.address) != null ? _ref.state : void 0);
        city = this.select('basedOnStateChange').val() || ((_ref1 = this.attr.data.address) != null ? _ref1.city : void 0);
        neighborhood = this.select('basedOnCityChange').val();
        stateCapitalize = _.find(rules.states, function(s) {
          return s.value === state;
        });
        if (!stateCapitalize || !city || !neighborhood) {
          return;
        }
        postalCode = (_ref2 = rules.map[stateCapitalize.label]) != null ? (_ref3 = _ref2[city]) != null ? _ref3[neighborhood] : void 0 : void 0;
        if (!postalCode) {
          return;
        }
        this.select('postalCodeSelector').val(postalCode);
        return this.addressKeysUpdated();
      };
      this.loading = function(ev, data) {
        if (ev != null) {
          ev.stopPropagation();
        }
        this.attr.data.loading = true;
        this.fillCitySelect();
        this.fillNeighborhoodSelect();
        return this.render();
      };
      this.profileUpdated = function(e, profile) {
        return this.attr.profileFromEvent = profile;
      };
      this.normalizeCities = function(city, cityNames, cleanCityNames) {
        var indexOfCityInList;
        indexOfCityInList = cleanCityNames.indexOf(this.cleanStr(city));
        if (indexOfCityInList > -1) {
          return cityNames[indexOfCityInList];
        }
        return city;
      };
      this.multipleOptionsRegex = new RegExp(/;|(?:::)/);
      this.hasMultipleOptions = function(field) {
        return this.multipleOptionsRegex.test(field);
      };
      this.splitMultipleOptions = function(field) {
        return field.split(this.multipleOptionsRegex);
      };
      fixFieldWithMultipleOptions = function(address, field, fieldWithOptions, rules) {
        var citiesArrayFromApi, cityNames, cleanCityNames, newFieldWithOptions, option, options, optionsInArray, _i, _len;
        newFieldWithOptions = null;
        if (address[fieldWithOptions] || (address[field] && _this.hasMultipleOptions(address[field]))) {
          newFieldWithOptions = [];
          options = address[fieldWithOptions] ? address[fieldWithOptions] : address[field];
          optionsInArray = _this.splitMultipleOptions(options);
          if (rules.cities && field === 'city' && address.state && rules.cities[address.state.toUpperCase()]) {
            citiesArrayFromApi = _this.splitMultipleOptions(address.city);
            cityNames = rules.cities[address.state.toUpperCase()];
            cleanCityNames = _.map(cityNames, _this.cleanStr);
            optionsInArray = _.map(citiesArrayFromApi, function(city) {
              return _this.normalizeCities(city, cityNames, cleanCityNames);
            });
          }
          address[field] = '';
          for (_i = 0, _len = optionsInArray.length; _i < _len; _i++) {
            option = optionsInArray[_i];
            if (option.length > 0) {
              newFieldWithOptions.push({
                value: option,
                label: option
              });
            }
          }
        }
        return newFieldWithOptions;
      };
      this.enable = function(ev, address, logisticsConfiguration) {
        var firstName, handleLoadFailure, handleLoadSuccess, lastName, _ref, _ref1, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7,
          _this = this;
        if (ev != null) {
          ev.stopPropagation();
        }
        firstName = ((_ref = window.vtexjs.checkout.orderForm) != null ? (_ref1 = _ref.clientProfileData) != null ? _ref1.firstName : void 0 : void 0) || ((_ref2 = this.attr.profileFromEvent) != null ? _ref2.firstName : void 0);
        lastName = ((_ref3 = window.vtexjs.checkout.orderForm) != null ? (_ref4 = _ref3.clientProfileData) != null ? _ref4.lastName : void 0 : void 0) || ((_ref5 = this.attr.profileFromEvent) != null ? _ref5.lastName : void 0);
        if (firstName && (address.receiverName === '' || !address.receiverName)) {
          address.receiverName = firstName + ' ' + lastName;
        }
        this.attr.data.address = new Address(address);
        this.attr.data.logisticsConfiguration = logisticsConfiguration;
        this.attr.data.storeAcceptsPostalCode = (__indexOf.call((_ref6 = this.attr.data.logisticsConfiguration) != null ? _ref6.acceptSearchKeys : void 0, 'postalCode') >= 0);
        this.attr.data.storeAcceptsGeoCoords = (__indexOf.call((_ref7 = this.attr.data.logisticsConfiguration) != null ? _ref7.acceptSearchKeys : void 0, 'geoCoords') >= 0);
        this.attr.data.addressQuery = address.addressQuery != null ? address.addressQuery : false;
        this.attr.data.hasGeolocationData = this.attr.data.address.geoCoordinates.length > 0 && this.attr.data.storeAcceptsGeoCoords;
        this.attr.data.comeFromGeoSearch = address.addressQuery != null;
        handleLoadSuccess = function() {
          var rules, _ref8;
          rules = _this.getCountryRule();
          if (rules) {
            _this.attr.data.neighborhoodsPostalCode = fixFieldWithMultipleOptions(address, 'neighborhood', 'neighborhoods', rules);
            _this.attr.data.citiesPostalCode = fixFieldWithMultipleOptions(address, 'city', 'cities', rules);
          }
          if ((rules != null ? rules.postalCodeByInput : void 0) && (rules != null ? (_ref8 = rules.masks) != null ? _ref8.postalCode : void 0 : void 0) && _this.attr.data.address.postalCode && _this.attr.data.address.postalCode.length > 0) {
            _this.attr.data.address.postalCode = _.maskString(_this.attr.data.address.postalCode, rules.masks.postalCode);
          }
          if (rules.country === 'UNI' && _this.attr.data.address.postalCode === '0') {
            _this.attr.data.isUniversalUsingPostalCode = false;
          }
          _this.attr.data.contractedShippingFieldsForGeolocation = false;
          _this.removeInvalidFields(_this.attr.data.address, rules);
          _this.updateEnables(_this.attr.data.address);
          _this.fillCitySelect();
          _this.fillNeighborhoodSelect();
          return _this.render().then(function() {
            return _this.attr.addressKeyMap = _this.getCurrentAddress();
          });
        };
        handleLoadFailure = function(reason) {
          throw reason;
        };
        return this.loadCountryRulesAndTemplate(this.attr.data.address.country).then(handleLoadSuccess, handleLoadFailure);
      };
      this.disable = function(ev) {
        if (ev != null) {
          ev.stopPropagation();
        }
        return this.$node.html('');
      };
      this.cleanStr = function(str) {
        if (str) {
          return _.plainChars(str.toLowerCase());
        } else {
          return '';
        }
      };
      this.hasOption = function(field, options) {
        var cleanField, cleanOptions, option, _i, _len,
          _this = this;
        cleanOptions = _.map(options, function(str) {
          return {
            clean: _this.cleanStr(str),
            value: str
          };
        });
        cleanField = this.cleanStr(field);
        for (_i = 0, _len = cleanOptions.length; _i < _len; _i++) {
          option = cleanOptions[_i];
          if (option.clean === cleanField) {
            return option.value;
          }
        }
        return false;
      };
      this.removeInvalidFields = function(address, rules) {
        var fixedCity, fixedNeighborhood, fixedState;
        fixedState = this.fixState(rules, address);
        if (fixedState) {
          fixedCity = this.fixCity(rules, address);
          if (fixedCity) {
            fixedNeighborhood = this.fixNeighborhood(rules, address);
          }
        }
        if (fixedState) {
          return address.state = address.state.toUpperCase();
        }
      };
      this.fixState = function(rules, address) {
        var addressState, hasStateInOptions, isValidState, _ref;
        if (address.state && (rules.postalCodeByState || rules.postalCodeByCity || rules.postalCodeByNeighborhood)) {
          isValidState = (_ref = rules.map) != null ? _ref[address.state] : void 0;
          if (!isValidState) {
            hasStateInOptions = this.hasOption(address.state, _.keys(rules.map));
            if (hasStateInOptions) {
              address.state = hasStateInOptions;
              return true;
            }
            address.postalCode = '';
            address.state = '';
            if (rules.basedOnStateChange) {
              address.city = '';
            }
            if (rules.basedOnCityChange) {
              address.neighborhood = '';
            }
            return false;
          } else {
            return true;
          }
        } else if (address.state && rules.postalCodeByInput && rules.states) {
          addressState = address.state.toUpperCase();
          isValidState = _.find(rules.states, function(state) {
            return state.value === addressState;
          });
          if (!isValidState) {
            address.state = '';
            return false;
          }
        }
        return false;
      };
      this.fixCity = function(rules, address) {
        var city, isValidCity, _ref;
        city = this.getCity(rules, address);
        if (city && (rules.postalCodeByCity || rules.postalCodeByNeighborhood)) {
          isValidCity = (_ref = rules.map[address.state]) != null ? _ref[city] : void 0;
          if (!isValidCity) {
            address.postalCode = '';
            this.setCity(rules, address, '');
            if (rules.basedOnCityChange) {
              address.neighborhood = '';
            }
            return false;
          } else {
            return true;
          }
        }
        return false;
      };
      this.fixNeighborhood = function(rules, address) {
        var city, isValidNeighborhood, _ref, _ref1, _ref2;
        city = this.getCity(rules, address);
        if (city && address.neighborhood && rules.postalCodeByNeighborhood) {
          isValidNeighborhood = (_ref = rules.map) != null ? (_ref1 = _ref[address.state]) != null ? (_ref2 = _ref1[address.city]) != null ? _ref2[address.neighborhood] : void 0 : void 0 : void 0;
          if (!isValidNeighborhood) {
            address.postalCode = '';
            address.neighborhood = '';
            return false;
          }
        }
        return true;
      };
      this.getCity = function(rules, address) {
        if (rules.swapNeighborhoodWithCity) {
          return address.neighborhood;
        }
        return address.city;
      };
      this.setCity = function(rules, address, value) {
        if (rules.swapNeighborhoodWithCity) {
          address.neighborhood = value;
        }
        return address.city = value;
      };
      this.stopSubmit = function(ev) {
        ev.preventDefault();
        return this.trigger('addressFormSubmit.vtex');
      };
      this.updateEnables = function() {
        var hasGeolocation, rules, validPostalCode, _ref;
        rules = this.getCountryRule();
        if (this.attr.data.address.geoCoordinates.length === 2 && this.attr.data.storeAcceptsGeoCoords) {
          if (((_ref = rules.regexes) != null ? _ref.postalCode : void 0) != null) {
            validPostalCode = rules.regexes.postalCode.test(this.attr.data.address.postalCode || '');
          } else {
            validPostalCode = true;
          }
          this.attr.data.contractedShippingFieldsForGeolocation = {
            neighborhood: this.attr.data.address.neighborhood !== '' && (this.attr.data.address.neighborhood != null),
            street: this.attr.data.address.street !== '' && (this.attr.data.address.street != null),
            city: this.attr.data.address.city !== '' && (this.attr.data.address.city != null),
            number: this.attr.data.address.number !== '' && (this.attr.data.address.number != null),
            state: this.attr.data.address.state !== '' && (this.attr.data.address.state != null),
            postalCode: this.attr.data.address.postalCode !== '' && (this.attr.data.address.postalCode != null) && validPostalCode
          };
        }
        if (rules.queryByPostalCode) {
          this.attr.data.labelShippingFields = this.attr.data.address.neighborhood !== '' && (this.attr.data.address.neighborhood != null) && this.attr.data.address.street !== '' && (this.attr.data.address.street != null) && this.attr.data.address.state !== '' && (this.attr.data.address.state != null) && this.attr.data.address.city !== '' && (this.attr.data.address.city != null) && alphanumponc(this.attr.data.address.neighborhood) && alphanumponc(this.attr.data.address.street) && alphanumponc(this.attr.data.address.state) && alphanumponc(this.attr.data.address.city) && !this.hasMultipleOptions(this.attr.data.address.neighborhood) && !this.hasMultipleOptions(this.attr.data.address.state) && !this.hasMultipleOptions(this.attr.data.address.street);
          this.attr.data.labelFields = {
            state: this.attr.data.address.state !== '' && (this.attr.data.address.state != null) && alphanumponc(this.attr.data.address.state) && !this.hasMultipleOptions(this.attr.data.address.state),
            city: this.attr.data.address.city !== '' && (this.attr.data.address.city != null) && alphanumponc(this.attr.data.address.city) && !this.hasMultipleOptions(this.attr.data.address.city),
            neighborhood: this.attr.data.address.neighborhood !== '' && (this.attr.data.address.neighborhood != null) && alphanumponc(this.attr.data.address.neighborhood) && !this.hasMultipleOptions(this.attr.data.address.neighborhood)
          };
          if (_.all(this.attr.data.labelFields, function(f) {
            return f === false;
          })) {
            this.attr.data.labelFields = null;
          }
          hasGeolocation = this.attr.data.address.geoCoordinates && this.attr.data.address.geoCoordinates.length === 2;
          return this.attr.data.disableCityAndState = !hasGeolocation && this.attr.data.address.state && this.attr.data.address.city && !this.hasMultipleOptions(this.attr.data.address.city) && !this.hasMultipleOptions(this.attr.data.address.state);
        }
      };
      this.googleMapsAPILoaded = function() {
        this.attr.data.loading = false;
        return this.createMap();
      };
      this.universalUsePostalCode = function(e) {
        e.preventDefault();
        this.attr.data.isUniversalUsingPostalCode = true;
        this.attr.reRenderUniversalPostalCode = true;
        return this.render();
      };
      this.universalDontUsePostalCode = function(e) {
        var _this = this;
        e.preventDefault();
        this.attr.data.isUniversalUsingPostalCode = false;
        this.attr.reRenderUniversalPostalCode = true;
        return this.render().then(function() {
          return _this.addressKeysUpdated();
        });
      };
      return this.after('initialize', function() {
        this.on('enable.vtex', this.enable);
        this.on('disable.vtex', this.disable);
        this.on('startLoading.vtex', this.loading);
        this.on('googleMapsAPILoaded.vtex', this.googleMapsAPILoaded);
        this.on(window, 'profileUpdated', this.profileUpdated);
        this.on('click', {
          'forceShippingFieldsSelector': this.forceShippingFields,
          'findAPostalCodeForAnotherAddressSelector': this.findAnotherPostalCode,
          'usePostalCodeSelector': this.universalUsePostalCode,
          'dontUsePostalCodeSelector': this.universalDontUsePostalCode,
          'searchAnotherAddressSelector': this.findAnotherPostalCode
        });
        this.on('change', {
          'stateSelector': this.changedStateHandler,
          'citySelector': this.changedCityHandler,
          'basedOnStateChange': this.changePostalCodeByCity,
          'basedOnCityChange': this.changePostalCodeByNeighborhood
        });
        this.on('keyup', {
          'postalCodeSelector': this.addressKeysUpdated
        });
        this.on('submit', {
          'addressFormSelector': this.stopSubmit
        });
        this.$node.on('blur', this.attr.universalPostalCodeSelector, this.addressKeysUpdated.bind(this));
        this.setValidators([this.validateAddress]);
        return this.setLocalePath('shipping/script/translation/');
      });
    };
    return defineComponent(AddressForm, withi18n, withCreateMap, withGoogleMaps, withValidation, withImplementedCountries);
  });

}).call(this);

